export default "__VITE_ASSET__C3GqFgpq__"